// ** React Imports
import React from 'react'

// ** MUI Components
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'


// ** Styles Import
import 'react-credit-cards/es/styles-compiled.css'
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import {useFormContext} from "react-hook-form";
import {ControlledTextField} from "../../../../components/forms";
import {SignupFields} from "../../../../types/user/authData";
import {Link} from "@mui/material";
import {useNavigate} from "react-router-dom";


const genreOpts = [
  {id: 'Masculino', descripcion: 'Masculino'},
  {id: 'Femenino', descripcion: 'Femenino'},
  {id: 'Otro', descripcion: 'Otro'}
]

const roleOpts = [
  {id: 'Empleado', descripcion: 'Empleado'},
  {id: 'Administrador', descripcion: 'Administrador'},
  {id: 'Gerente', descripcion: 'Gerente'},
  {id: 'Otro', descripcion: 'Otro'}
]

const phoneOpts = [
  {id: 'Fijo', descripcion: 'Fijo'},
  {id: 'Celular', descripcion: 'Celular'}
]

const StepPersonalInfo = ({ handleNext }: { [key: string]: () => void }) => {
  const methods = useFormContext()
  const navigate = useNavigate()
  
  return (
    <>
      <Box sx={{ mb: 4 }}>
        <Typography variant='h5'>Datos personales del solicitante</Typography>
        <Typography sx={{ color: 'text.secondary' }}>Ingrese los datos solicitados para seguir</Typography>
      </Box>

      <Grid container spacing={5}>
        <Grid item xs={12} sm={6}>
          <ControlledTextField control={methods.control}
                               name={SignupFields.Nombre}
                               label={'Nombre'}
                               fullWidth
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <ControlledTextField control={methods.control}
                               name={SignupFields.Apellido}
                               label={'Apellido'}
                               fullWidth
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <ControlledTextField control={methods.control}
                               name={SignupFields.DNI}
                               label={'DNI'}
                               fullWidth
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <ControlledTextField control={methods.control}
                               name={SignupFields.Genero}
                               label={'Genero'}
                               fullWidth
                               select
                               options={genreOpts}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <ControlledTextField control={methods.control}
                               name={SignupFields.Cargo}
                               label={'Cargo'}
                               fullWidth
                               select
                               options={roleOpts}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <ControlledTextField control={methods.control}
                               name={SignupFields.TipoCelular}
                               label={'Tipo de Telefono'}
                               fullWidth
                               select
                               options={phoneOpts}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <ControlledTextField control={methods.control}
                               name={SignupFields.CodArea}
                               label={'Cód. Area'}
                               fullWidth
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <ControlledTextField control={methods.control}
                               name={SignupFields.Telefono}
                               label={'Teléfono'}
                               fullWidth
          />
        </Grid>
        <Grid item xs={12}>
          <Box
              sx={{ mb: 4, display: 'flex', alignItems: 'center', flexWrap: 'wrap', justifyContent: 'space-between' }}
          >
            <FormControlLabel control={<Checkbox />} label='Los datos ingresados corresponden al solicitante' />
          </Box>
          <Link underline={"none"} sx={{ cursor: 'pointer' }} color={'#00b2c9'} onClick={() => {navigate('/login')}}>
            ¿Ya tenés cuenta? Hacé click acá para ingresar
          </Link>
        </Grid>
        <Grid item xs={12}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <Button color='primary' variant='contained' onClick={handleNext}>
              Siguiente
            </Button>
          </Box>
        </Grid>
      </Grid>
    </>
  )
}

export default StepPersonalInfo
